"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressSteps = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const icon_complete_1 = require("./icon-complete");
const icon_current_1 = require("./icon-current");
const icon_future_1 = require("./icon-future");
const lodash_1 = require("lodash");
function ProgressSteps({ steps, currentStep }) {
    const isCompleteStep = (stepIndex) => currentStep >= stepIndex;
    const isCurrentStep = (stepIndex) => currentStep === stepIndex;
    const isLastStep = (stepIndex) => stepIndex === steps.length - 1;
    const renderIcon = (stepIndex) => {
        return ((0, jsx_runtime_1.jsx)("div", { "aria-hidden": true, children: isCurrentStep(stepIndex) ? ((0, jsx_runtime_1.jsx)(icon_current_1.IconCurrent, {})) : isCompleteStep(stepIndex) ? ((0, jsx_runtime_1.jsx)(icon_complete_1.IconComplete, {})) : ((0, jsx_runtime_1.jsx)(icon_future_1.IconFuture, {})) }));
    };
    const renderTitle = (stepIndex) => {
        const step = steps[stepIndex];
        const classes = {
            "text-2xl": true,
            "font-bold": isCurrentStep(stepIndex),
        };
        return (0, jsx_runtime_1.jsx)("div", { className: (0, classnames_1.default)(classes), children: step.title });
    };
    const renderLine = () => {
        // 2 * 11px margin + 2 * 1px border = 24px to match width of icons
        return ((0, jsx_runtime_1.jsx)("div", { "data-testid": "progress-line", className: "mx-[11px] min-h-[32px] border border-solid border-gr-progress-line" }));
    };
    const renderSubTitles = (stepIndex) => {
        const step = steps[stepIndex];
        return ((0, jsx_runtime_1.jsx)("div", { className: "ml-2 text-base overflow-x-hidden", children: step.subTitles.map(title => ((0, jsx_runtime_1.jsx)("div", { className: "truncate", children: title }, (0, lodash_1.uniqueId)(title)))) }));
    };
    return ((0, jsx_runtime_1.jsx)("div", { className: "flex flex-col gap-0.5", children: steps.map((step, stepIndex) => ((0, jsx_runtime_1.jsxs)(react_1.default.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex gap-3 items-center", children: [renderIcon(stepIndex), renderTitle(stepIndex)] }), !isLastStep(stepIndex) && ((0, jsx_runtime_1.jsxs)("div", { className: "flex gap-3", children: [renderLine(), renderSubTitles(stepIndex)] }))] }, `${stepIndex}-${step.title}`))) }));
}
exports.ProgressSteps = ProgressSteps;
